import React, { FC } from 'react'

import Price from '@/checkout-instore-legacy/components/Commons/Price'
import { getSummaryTotals } from '@/checkout-instore-legacy/summary/utils'

export interface OrderFormPriceProps {
  order: any
  items: Item[]
  hasAtLeastOneValidItem?: boolean
  shippingWasFilled: boolean
}

type Props = OrderFormPriceProps

const OrderFormPrice: FC<Props> = ({
  order,
  items,
  hasAtLeastOneValidItem,
  shippingWasFilled,
}) => {
  const orderForm = order.orderForm
  const { total, itemsTotal, discount } = getSummaryTotals(order.orderForm)

  if (
    (!orderForm && items.length < 0) ||
    !hasAtLeastOneValidItem ||
    total == null
  ) {
    return null
  }

  const summaryTotal = shippingWasFilled
    ? total
    : Math.max(itemsTotal - (discount || 0), 0)

  // TODO: this error popped up when moving the checkout-instore project
  // to checkout-instore-legacy, but needs to be fixed at some point
  // @ts-ignore
  return <Price value={summaryTotal} />
}

OrderFormPrice.defaultProps = {
  hasAtLeastOneValidItem: false,
}

export default OrderFormPrice
